// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { autoDeliveryTableStyles } from "@guestsupply/App/Widgets/AutoDelivery/AutoDeliveryTable";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import Cart from "@guestsupply/XDL/Icons/Cart";
import { xScreen } from "@guestsupply/XDL/Utilities";
import color from "@guestsupply/XDL/Utilities/color";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities/sharedStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronsRight from "@insite/mobius/Icons/ChevronsRight";
import Edit from "@insite/mobius/Icons/Edit";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

autoDeliveryTableStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
    `,
};
autoDeliveryTableStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

autoDeliveryTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

autoDeliveryTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
    css: css`
        margin-top: 20px;
    `,
};
autoDeliveryTableStyles.autoDeliveryTableTitleWrapper = {
    css: css`
        &&& {
            width: 100%;
            margin: 15px 0;
        }
    `,
};

autoDeliveryTableStyles.autoDeliveryTableTitleText = {
    size: 24,
};

autoDeliveryTableStyles.orderScheduleCells = {
    css: css`
        vertical-align: top;
        font-size: 13px;
    `,
};
autoDeliveryTableStyles.orderPoCells = {
    css: css`
        vertical-align: top;
        width: 100px;
        ${xScreen("lte", "lg")} {
            ${TypographyStyle} {
                white-space: nowrap;
            }
        }
    `,
    typographyProps: {
        css: css`
            vertical-align: top;
        `,
    },
};
autoDeliveryTableStyles.orderShipToCells = {
    css: css`
        vertical-align: top;
        max-width: 500px;
        ${xScreen("lte", "lg")} {
            min-width: 500px;
        }
    `,
    typographyProps: {
        css: css`
            vertical-align: top;
        `,
    },
};
autoDeliveryTableStyles.orderEmailNotificationCells = {
    css: css`
        vertical-align: top;
        min-width: 170px;
    `,
};
autoDeliveryTableStyles.orderActionsCells = {
    css: css`
        vertical-align: top;
    `,
};

autoDeliveryTableStyles.productSubscCells = {
    css: css`
        max-width: 500px;
        ${xScreen("lte", "lg")} {
            min-width: 500px;
        }
    `,
};
autoDeliveryTableStyles.productImageClickable = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        width: 100px;
        height: 100px;
    `,
};

autoDeliveryTableStyles.productImage = {
    css: css`
        img {
            max-height: 100%;
            max-width: 100%;
        }
    `,
};
autoDeliveryTableStyles.productWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
    `,
};
autoDeliveryTableStyles.productPartNumber = {
    as: "span",
    size: 13,
    css: css`
        padding-bottom: 10px;
    `,
};
autoDeliveryTableStyles.productShorDescription = {
    as: "span",
    color: "primary",
    size: 13,
    css: css`
        &&&& {
            ${xScreen("lte", "lg")} {
                white-space: normal;
            }
        }
    `,
};
autoDeliveryTableStyles.productInfo = {
    css: css`
        display: flex;
        flex-direction: column;
        white-space: normal;
        padding-left: 10px;
    `,
};

autoDeliveryTableStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
autoDeliveryTableStyles.skippedText = {
    as: "span",
    size: 13,
    color: "warning.main",
    css: css`
        display: block;
    `,
};

autoDeliveryTableStyles.orderNowLink = {
    ...createLinkIconStyles(Cart, {
        typographyProps: {
            size: 12,
            lineHeight: "20px",
            weight: "normal",
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    font-weight: 700;
                    opacity: 1;
                `,
            },
            position: "left",
        },
        css: css`
            margin-bottom: 10px;
        `,
    }),
};
autoDeliveryTableStyles.skipOrderLink = {
    ...createLinkIconStyles(ChevronsRight, {
        typographyProps: {
            size: 12,
            lineHeight: "20px",
            weight: "normal",
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    font-weight: 700;
                    opacity: 1;
                `,
            },
            position: "left",
        },
        css: css`
            margin-bottom: 10px;
            &:disabled {
                color: ${color("primary", 0.33)};
                & ${TypographyStyle} {
                    color: ${color("primary", 0.33)};
                }
            }
        `,
    }),
};
autoDeliveryTableStyles.editOrderLink = {
    ...createLinkIconStyles(Edit, {
        typographyProps: {
            size: 12,
            lineHeight: "20px",
            weight: "normal",
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    font-weight: 700;
                    opacity: 1;
                `,
            },
            position: "left",
        },
        css: css`
            margin-bottom: 10px;
        `,
    }),
};

autoDeliveryTableStyles.repeationStyle = {
    cssOverrides: {
        inputSelect: css`
            display: block;
        `,
    },
};

const headerStyles = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        weight: 500,
    },
};

autoDeliveryTableStyles.orderScheduleHeader = headerStyles;
autoDeliveryTableStyles.productSubscHeader = headerStyles;
autoDeliveryTableStyles.orderPoHeader = headerStyles;
autoDeliveryTableStyles.orderShipToHeader = headerStyles;
autoDeliveryTableStyles.orderEmailNotificationHeader = headerStyles;
autoDeliveryTableStyles.orderActionsHeader = headerStyles;
